import { $http } from "@/utils/http";
import { SET_RECOMMENDED_LIST, SET_RECOMMENDED_LIST_LOADING, SET_RECOMMENDED_LIST_LENGTH } from "../mutation-types";

import { GET_RECOMMENDED_LIST } from "../action-types";

const state = {
    recommendedList: null,
    recommendedListLoading: false,
    recommendedListLength: 0,
    limit: 15,
    activeCategory: "rating",
};

const getters = {
    recommendedList: state => state.recommendedList,
    recommendedListLoading: state => state.recommendedListLoading,
    recommendedListLength: state => state.recommendedListLength,
    activeCategory: state => state.activeCategory,
};

const actions = {
    [GET_RECOMMENDED_LIST]: async ({ commit }) => {
        commit(SET_RECOMMENDED_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/top-products?per-page=${state.skip}&sort=${state.activeCategory}`);
            commit(SET_RECOMMENDED_LIST, response.data.data);
            commit(SET_RECOMMENDED_LIST_LENGTH, response.data.data.length);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_RECOMMENDED_LIST_LOADING, false);
        }
    },
};

const mutations = {
    [SET_RECOMMENDED_LIST](state, list) {
        state.recommendedList = list;
    },
    [SET_RECOMMENDED_LIST_LOADING](state, status) {
        state.recommendedListLoading = status;
    },
    [SET_RECOMMENDED_LIST_LENGTH](state, data) {
        state.recommendedListLength = data;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
